import Vue from 'vue';
import Router from 'vue-router';
import paths from './paths';
import NProgress from 'nprogress';
import 'nprogress/nprogress.css';

Vue.use(Router);
const router =  new Router({
  mode: 'hash',
  linkActiveClass: 'active',
  routes: paths,
  scrollBehavior (to, from, savedPosition) {
    return { x: 0, y: 0 }
  }
});
// router gards
router.beforeEach((to, from, next) => {
  NProgress.start();
  next();
});

router.afterEach((to, from) => {
  NProgress.done();
});

export default router;
